import { ceil, round } from 'lodash';
import React from 'react';
import { DataForDesignDrawingsManifold } from '../../designs/data-for-design-drawings/dataForDesignDrawingsResponse';
import { PortRow } from './templates/PortRow';

type Props = {
  manifold: DataForDesignDrawingsManifold;
  precision?: 2 | 1;
  roundingMethod?: 'Ceiling' | 'Round';
};

const roundOrCeiling = (value: number, precision: number, roundingMethod: 'Ceiling' | 'Round') => {
  return roundingMethod === 'Ceiling' ? ceil(value, precision) : round(value, precision);
};
export const MinimumFlowRateRow = ({ manifold, precision = 2, roundingMethod = 'Round' }: Props) => {
  return (
    <PortRow
      name="Minimum Flow Rate per Port (l/min)"
      manifold={manifold}
      getValue={room =>
        room.heatLossAndHeatOutput != null
          ? roundOrCeiling(
              room.heatLossAndHeatOutput.flowRateInLitresPerMinute / room.numberOfPorts,
              precision,
              roundingMethod,
            )
          : ''
      }
    />
  );
};
